export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=707d39effb7d486ac5f3c2ab15bec20d40f2264709&name=pushAdClickData!'